<template>
	<vs-popup :title="$t('Affecter un collaborateur')" :active.sync="localVisible">
		<div class="ml-2">
			<span> {{ $t("Sélection des collaborateurs pour les entreprises suivantes") }} : </span>
			<ul>
				<li v-for="(app, index) in apps" :key="index" class="text-sm ml-6">
					<span> – </span> <span class="pl-2"> {{ app.organization?.name || app.identifiant }} </span>
				</li>
			</ul>
		</div>

		<div class="mb-4">
			<input
				v-model="collaborator_search"
				type="text"
				:placeholder="$t('Rechercher un collaborateur')"
				class="w-full vs-input mt-5 search-input"
			/>
		</div>

		<!-- <div
			v-if="
				apps.length == 1 &&
				filteredCollaborators.length > 0 &&
				filteredCollaborators.every(c => c.policy_profile.name === 'Support technique')
			"
			class="ml-2 mb-4"
		>
			<span> {{ $t("Sélectionner l’utilisateur qui a demandé l’accès à l’entreprise") }} : </span>
			<select
				v-model="userId"
				class="flex items-center justify-between border px-3 py-2 text-sm w-full"
				:style="{
					'border-color': 'var(--border)',
					'background-color': 'transparent',
					'border-radius': '6px !important'
				}"
			>
				<option
					v-for="(user, index) in [...apps[0].policies.map(p => p.user), apps[0].admin]"
					:key="index"
					:value="user.id"
				>
					{{ user.email }}
					<span v-if="user.firstname"> – {{ user.name }} </span>
				</option>
			</select>
		</div> -->

		<div class="w-full border-solid border rounded-lg overflow-y-auto" style="border-color: var(--border)">
			<table class="w-full border-collapse border-spacing-0">
				<thead class="text-xs bg-grey-light border-b">
					<tr class="border-spacing-0">
						<th class="px-4 pt-2 text-md text-left" style="width: 48px">
							<input
								v-model="select_all_checked_model"
								class="w-5 h-5 cursor-pointer"
								type="checkbox"
								@change="toggleAllCollaborators()"
							/>
						</th>
						<th class="px-4 pt-2 text-md text-left w-200">{{ $t("Nom") }}</th>
						<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Rôle") }}</th>
						<th class="px-4 pt-2 text-md font-semibold text-center w-200">{{ $t("Entreprises") }}</th>
					</tr>
				</thead>

				<tbody class="w-full">
					<tr v-for="(item, index_c) in collaborators" :key="index_c" class="border-b">
						<td class="px-4 flex">
							<div class="flex items-center justify-center" style="height: 40.5px">
								<input
									type="checkbox"
									class="w-5 h-5 cursor-pointer"
									:checked="isCollaboratorSelected(item)"
									@change="toggleSelection(item)"
								/>
							</div>
						</td>

						<td class="pr-4 py-1" :style="{ 'max-width': '200px' }">
							<vs-tooltip :text="item.user.email">
								<div class="flex items-center">
									<img
										:src="getImageUrl(item.user)"
										class="rounded-full"
										height="28px"
										width="28px"
										:alt="$t('Logo de l’entreprise')"
										style="object-fit: contain"
									/>

									<p class="pl-2 text-left text-md truncate">
										{{ item.user.name }}
									</p>
								</div>
							</vs-tooltip>
						</td>

						<td class="text-left px-4" :style="{ width: '145px' }">
							{{ $t(item.policy_profile.name) }}
						</td>

						<td class="text-center px-4">
							<div class="flex justify-center items-center">
								<span v-if="item.apps_by_policies.length == 0" class="text-grey text-sm italic">
									{{ $t("Aucune entreprise") }}
								</span>

								<template v-else>
									<vs-tooltip
										v-for="(app, index_app) in item.apps_by_policies"
										:key="index_app"
										:color="stringToHSLColor(app.name)"
										:text="app.name"
									>
										<div
											class="rounded-full shadow-md text-white uppercase text-lg font-medium"
											:style="{
												'background-color': stringToHSLColor(app.name),
												width: '28px',
												height: '28px',
												'margin-left': '-8px',
												'line-height': '28px'
											}"
										>
											{{ app.name.substring(0, 1) }}
										</div>
									</vs-tooltip>
								</template>
							</div>
						</td>
					</tr>

					<tr v-if="collaborators == null || collaborators.length == 0">
						<td colspan="7" class="text-center py-4 italic text-grey-light">
							{{ $t("Aucun collaborateur trouvé") }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="flex flex-row items-center justify-center w-full mt-4" style="gap: 12px">
			<s-button
				type="border"
				class="sm:m-base float-none sm:float-left h-8 px-4 py-2 text-sm"
				style="margin: 0 !important"
				@click="$emit('close')"
			>
				{{ $t("Annuler") }}
			</s-button>

			<s-button
				class="sm:m-base float-none sm:float-right h-8 px-4 py-2 text-sm"
				:disabled="
					loading_save_collaborators ||
					(collaborators_to_add.length === 0 && collaborators_to_delete.length === 0)
				"
				style="margin: 0 !important"
				@click="sendInvitation"
			>
				{{ $t("Enregistrer") }}
			</s-button>
		</div>
	</vs-popup>
</template>

<script>
	import { mapGetters, mapState } from "vuex";
	import debounce from "lodash/debounce";
	import collaborators from "@/views/Collaborators.vue";

	export default {
		name: "ModalAssignCompaniesToCollaborators",
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			apps: {
				type: Array,
				default: () => []
			},
			partnerId: {
				type: Number,
				default: null
			},
			filteredCollaborators: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				localVisible: this.visible,
				selectedCollaborators: [],
				loading_save_collaborators: false,
				userId: null,
				select_all_checked_model: false, // model for select all checkbox
				collaborators: [],
				collaborator_search: "",
				collaborator_last_search: "",
				debouncedFilter: null,
				alreadySelectedCollaborators: []
			};
		},
		computed: {
			...mapGetters(["getCollaborators", "getImageUrl", "stringToHSLColor"]),
			...mapState(["loadedPolicies", "loadedCases", "user"]),
			collaborators_to_add() {
				return this.selectedCollaborators.filter(
					collaborator =>
						!this.alreadySelectedCollaborators.find(collaborator2 => collaborator2.id === collaborator.id)
				);
			},
			collaborators_to_delete() {
				return this.alreadySelectedCollaborators.filter(
					collaborator =>
						!this.selectedCollaborators.find(collaborator2 => collaborator2.id === collaborator.id)
				);
			}
		},
		watch: {
			apps: {
				handler(newApps) {
					if (!newApps) return;
					if (this.$store.state.loadedPolicies == null) this.$store.dispatch("getPolicies", newApps[0].id);

					this.initSelectedCollaborators();
				},
				deep: true,
				immediate: true
			},
			visible: {
				handler(newVal) {
					this.localVisible = newVal;
				},
				immediate: true
			},
			localVisible: {
				handler(newVal) {
					this.$emit("update:visible", newVal);
				}
			},
			filteredCollaborators: {
				handler(newVal) {
					this.collaborators = newVal;
				},
				immediate: true
			},
			collaborator_search(newValue) {
				if (newValue === this.collaborator_last_search) return;
				this.collaborator_last_search = newValue;
				this.debouncedFilter();
			}
		},
		created() {
			this.debouncedFilter = debounce(() => {
				this.collaborators = this.filteredCollaborators.filter(c =>
					c.user.name.toLowerCase().includes(this.collaborator_search.toLowerCase())
				);
			}, 500);
		},
		mounted() {
			//this.selectedCollaborators = this.initSelectedCollaborators();
		},
		methods: {
			initSelectedCollaborators_old() {
				this.filteredCollaborators.forEach(collaborator => {
					if (
						collaborator.apps_by_policies.some(
							app => this.apps.find(a => a.id === app.app_id) !== undefined
						)
					) {
						this.selectedCollaborators.push(collaborator);
						this.alreadySelectedCollaborators.push(collaborator);
					}
				});
			},
			initSelectedCollaborators() {
				this.selectedCollaborators = [];
				this.alreadySelectedCollaborators = [];
				this.filteredCollaborators.forEach(collaborator => {
					console.log(collaborator.apps_by_policies);
					if (this.apps.every(app => collaborator.apps_by_policies.some(a => a.app_id === app.id))) {
						this.selectedCollaborators.push(collaborator);
						this.alreadySelectedCollaborators.push(collaborator);
					}
				});
			},
			async sendInvitation() {
				// Vérifier s'il y a des collaborateurs avec le rôle "Support technique"
				const supportTechniqueCollaborators = this.collaborators_to_add.filter(
					collaborator => collaborator.policy_profile.name === "Support technique"
				);

				// Si des collaborateurs "Support technique" sont sélectionnés, afficher la confirmation
				if (supportTechniqueCollaborators.length > 0) {
					const collaboratorNames = supportTechniqueCollaborators
						.map(c => c.user.firstname + " " + c.user.lastname)
						.join(", ");

					const title =
						supportTechniqueCollaborators.length === 1
							? this.$t("Envoyer une demande d’accès ?")
							: this.$t("Envoyer une demande d’accès aux entrerprises selectionnés ?");

					const object = { name: collaboratorNames, names: collaboratorNames };
					const text =
						supportTechniqueCollaborators.length === 1
							? this.$t("Un email sera envoyé pour lui proposer un accès temporaire à son ...", object)
							: this.$t("Un email sera envoyé pour lui proposer un accès temporaire aux ...", object);

					this.$vs.dialog({
						type: "confirm",
						title,
						text,
						accept: () => this.proceedWithInvitation(),
						cancel: () => {},
						acceptText: this.$t("Envoyer"),
						cancelText: this.$t("Annuler")
					});
				} else {
					// Pas de collaborateurs "Support technique", procéder directement
					this.proceedWithInvitation();
				}
			},
			async proceedWithInvitation() {
				if (this.loadedPolicies == null) await this.$store.dispatch("getPolicies", this.apps[0].id);

				const accountPolicy = this.loadedPolicies.find(policy => policy.name === "Comptable");
				const supportTechniquePolicy = this.loadedPolicies.find(policy => policy.name === "Support technique");

				if (!accountPolicy && !supportTechniquePolicy) {
					this.$vs.notify({
						text: this.$t("Impossible de trouver le profil de politique Comptable ou Support Technique."),
						color: "warning",
						position: "bottom-right"
					});
					return;
				}

				this.loading_save_collaborators = true;
				const allInvitesAccountants = [];
				const allInvitesSupportTechnique = [];

				for (const app of this.apps) {
					for (const collaborator of this.collaborators_to_add) {
						if (accountPolicy && accountPolicy.id == collaborator.policy_profile_id) {
							allInvitesAccountants.push(
								this.$store.dispatch("sendInviteMail", {
									appId: app.id,
									email: collaborator.user.email,
									policyProfileId: collaborator.policy_profile_id,
									firstname: encodeURIComponent(collaborator.user.firstname),
									lastname: encodeURIComponent(collaborator.user.lastname)
								})
							);
						}

						if (supportTechniquePolicy && supportTechniquePolicy.id == collaborator.policy_profile_id) {
							allInvitesSupportTechnique.push(
								this.$store.dispatch("assignSupportCollaborator", {
									partnerId: this.partnerId,
									id: collaborator.id,
									appId: app.id,
									userId: this.userId || null
								})
							);
						}
					}
				}

				try {
					if (allInvitesAccountants.length > 0) await Promise.all(allInvitesAccountants);
					if (allInvitesSupportTechnique.length > 0) await Promise.all(allInvitesSupportTechnique);
					if (this.collaborators_to_delete.length > 0) await this.deleteCollaboratorsAccess();

					if (allInvitesAccountants.length > 0 || allInvitesSupportTechnique.length > 0) {
						this.$vs.notify({
							text: this.$t("Toutes les invitations ont été envoyées."),
							color: "success",
							position: "bottom-right"
						});
					}
					if (this.collaborators_to_delete.length > 0) {
						this.$vs.notify({
							text: this.$t("Collaborators removed successfully."),
							color: "success",
							position: "bottom-right"
						});
					}
				} catch (error) {
					this.$vs.notify({
						text:
							this.$t(error.response?.data?.message) ||
							this.$t("Erreur lors de l’envoi d’une ou plusieurs invitations."),
						color: "danger",
						position: "bottom-right"
					});
				} finally {
					this.loading_save_collaborators = false;
					this.selectedCollaborators = [];
					this.localVisible = false;
					this.$emit("update");
				}
			},
			isCollaboratorSelected(collaborator) {
				return this.selectedCollaborators.some(item => item.id === collaborator.id);
			},
			toggleSelection(collaborator) {
				const isSelected = this.selectedCollaborators.some(item => item.id === collaborator.id);
				if (isSelected)
					this.selectedCollaborators = this.selectedCollaborators.filter(item => item.id !== collaborator.id);
				else this.selectedCollaborators.push(collaborator);
			},
			toggleAllCollaborators() {
				if (!this.select_all_checked_model) {
					this.selectedCollaborators = [];
				} else if (this.select_all_checked_model) {
					this.selectedCollaborators = [...this.collaborators];
				}
			},
			async deleteCollaboratorsAccess() {
				const delete_promises = [];
				for (const collaborator of this.collaborators_to_delete) {
					for (const app of this.apps) {
						const payload = {
							appId: app.id,
							userId: collaborator.user_id
						};
						delete_promises.push(this.$store.dispatch("deleteAccess", payload));
					}
				}
				await Promise.all(delete_promises);
			}
		}
	};
</script>

<style scoped>
	.text-grey {
		color: var(--grey);
	}
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}

	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.modal-container {
		width: 300px;
		margin: 0px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.search-input {
		border-radius: 6px;
	}

	.search-input:focus-within {
		border: 1px solid var(--black);
	}

	.search-input {
		width: 100%;
		margin-bottom: 0px;
		border: 1px solid var(--border);
		padding: 8px 12px;
	}
</style>

<style>
	.vs-tooltip,
	.con-vs-dialog {
		z-index: 99999 !important;
	}
</style>
